import React, { useEffect, useState, useContext } from "react"
import Flatpickr from "react-flatpickr"

import {
    Col,
    Row,
    Card,
    CardBody,
    Container,
    Label,
    Input,
    InputGroup,
    Form,
    FormFeedback,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Button,
    Spinner,
    CardFooter,
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import ModalContext from "../../contexts/ModalContext"
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang"
import moment from "moment"
import MyEditor from "components/MyEditor"
import UploadFileS3 from "components/UploadFileS3"
import InputAttachment from "components/Input/attachment/InputAttachment"
import PopupAttachment from "components/Input/attachment/PopupAttachment"
import UploadDesc from "components/UploadDesc"
import { ReactSortable } from "react-sortablejs"
import Sortable from "sortablejs"
import Spinners from "components/Common/Spinner"
import { slugify } from "helpers/fn_helper";

// Service
import {
    CreateContent,
    GetContentById,
    UpdateContent,
    ContactUsFormById,
} from "./services/Services.js"

import CardPieceTopic from "./components/CardPieceTopic"
import Error401 from "components/Error401"

const STATUS_OPTION = fn_helper.OPTIONS.STATUS_NO_DELETE

const _routeLink = `contact-us/contact-us-form`
const _pageName = `Contact Us Form`
const _routePermission = `contact-us:contact-us-form`

const ContactUsFormTemplate = ({
    pageName = "",
    pageView = "create",
    componentKey = "",
}) => {
    // POPUP
    const { mAlert } = useContext(ModalContext)

    // OTHER STATE
    const qParams = useParams()
    const qLang = _.upperCase(qParams?.lang) ?? "TH"
    const qMainId = qParams?.id
    const navigate = useNavigate()

    const [waitSendData, setWaitSendData] = useState(false)
    const [contentLoading, setContentLoading] = useState(false)


    // ========== Form Validation ========== //
    const validationSchema = Yup.object({
        lang: Yup.string(),
        name: Yup.string(),
        email: Yup.string(),
        topic: Yup.string(),
        message: Yup.string(),

        postDate: Yup.string(),
        mainStatus: Yup.string(),
    })

    // LOCAL STATE FORM
    const [updatedValidationSchema, setUpdatedValidationSchema] =
        useState(validationSchema)

    const initialValues = {
        lang: "",
        name: "",
        email: "",
        topic: "",
        message: "",

        postDate: "",
        mainStatus: "",
    }

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: updatedValidationSchema,
    })

    const preFilInput = (resData = {}) => {
        console.log("🚀 ~ preFilInput ~ resData:", resData)
        // resetForm(validation.values, initialValues)

        // ถ้าไม่หน่วงมันจะแย่งกันทำ
        // validation.setFieldValue("contentId", resData?.contentId ?? "")
        validation.setFieldValue("lang", resData?.lang ?? "")
        validation.setFieldValue("name", resData?.name ?? "")
        validation.setFieldValue("email", resData?.email ?? "")

        // validation.setFieldValue("contentTopicKey", resData?.contentTopicKey ?? "")
        validation.setFieldValue("topic", resData?.topic ?? "")
        validation.setFieldValue("message", resData?.message ?? "")

        validation.setFieldValue(
            "postDate",
            resData?.postDate ?? moment().format("YYYY-MM-DD")
        )
        validation.setFieldValue(
            "mainStatus",
            resData?.mainStatus ?? "active"
        )
    }

    const API = {
        fetchGetContentById: async payload => {
            try {
                const response = await ContactUsFormById(payload.id, {
                    lang: qLang,
                })
                const resData = response.data
                if (resData.status == 200) {
                    preFilInput(resData.data)
                }
            } catch (err) {
                console.log("err ", err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong 001",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setContentLoading(false)
            }
        },
    }

    // กรณี Edit
    useEffect(() => {
        if (["update", "view"].includes(pageView)) {
            const payload = { id: qMainId }
            setContentLoading(true)
            API.fetchGetContentById(payload)
            // API.fetchGetContentPageSetting(componentKey)
        }
    }, [qLang])

    const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
    document.title = `${_pageName} | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

    const itemStyle = {
        padding: "10px",
        border: "1px solid black",
        margin: "5px",
        borderRadius: "8px",
        background: "#f9f9f9",
        transition: "transform 0.2s ease, background-color 0.3s ease",
    }

    const mapValues = (list = []) =>
        list.map(item => {
            const newObj = {
                attachmentId: item.attachmentId,
                sequence: item.sequence,
            }
            return newObj
        })
    
    if(!checkScope(`${_routePermission}:create`) || !checkScope(`${_routePermission}:update`) || !checkScope(`${_routePermission}:view`)) {
        return <Error401 />
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title={`${PAGE_VIEW} ${_pageName}`}
                        breadcrumbItems={[
                            { title: _pageName, link: "" },
                            { title: PAGE_VIEW },
                        ]}
                    />

                    {/* Render Form */}
                    {contentLoading ? (
                        <Spinners setLoading={setContentLoading} />
                    ) : (
                        <Row>
                            <Col className="col-12">
                                <FormikProvider value={validation}>
                                    <Form
                                        className="form-horizontal"
                                        onSubmit={e => {
                                            e.preventDefault()
                                            validation.handleSubmit()
                                            return false
                                        }}
                                    >
                                        <Row>
                                            <Col className="col-8">
                                                <Row>
                                                    <Col className="col-12">
                                                        <Card>
                                                            <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                                                <i className="bx bx-cube-alt"></i> {pageName}
                                                            </h5>
                                                            <CardBody>
                                                                <Row>
                                                                    <Col className="col-12 mb-3">
                                                                        <label
                                                                            htmlFor="lang"
                                                                            className="col-md-12 col-form-label"
                                                                        >
                                                                            Lang
                                                                            <span className="t-require">*</span>
                                                                        </label>
                                                                        <div className="col-md-12">
                                                                            <Input
                                                                                id="lang"
                                                                                className="form-control"
                                                                                type="text"
                                                                                placeholder=""
                                                                                name="lang"
                                                                                onChange={e => {
                                                                                    validation.setFieldValue(
                                                                                        "lang",
                                                                                        e.target.value
                                                                                    )
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.lang}
                                                                                invalid={
                                                                                    validation.touched.lang &&
                                                                                        validation.errors.lang
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                                disabled={pageView === "view"}
                                                                            />
                                                                            {validation.touched.lang &&
                                                                                validation.errors.lang && (
                                                                                    <FormFeedback type="invalid">
                                                                                        {validation.errors.lang}
                                                                                    </FormFeedback>
                                                                                )}
                                                                        </div>
                                                                        <hr />
                                                                    </Col>
                                                                    <Col className="col-12 mb-3">
                                                                        <label
                                                                            htmlFor="name"
                                                                            className="col-md-12 col-form-label"
                                                                        >
                                                                            Full Name
                                                                            <span className="t-require">*</span>
                                                                        </label>
                                                                        <div className="col-md-12">
                                                                            <Input
                                                                                id="name"
                                                                                className="form-control"
                                                                                type="text"
                                                                                placeholder=""
                                                                                name="name"
                                                                                onChange={e => {
                                                                                    validation.setFieldValue(
                                                                                        "name",
                                                                                        e.target.value
                                                                                    )
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.name}
                                                                                invalid={
                                                                                    validation.touched.name &&
                                                                                        validation.errors.name
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                                disabled={pageView === "view"}
                                                                            />
                                                                            {validation.touched.name &&
                                                                                validation.errors.name && (
                                                                                    <FormFeedback type="invalid">
                                                                                        {validation.errors.name}
                                                                                    </FormFeedback>
                                                                                )}
                                                                        </div>
                                                                        <hr />
                                                                    </Col>
                                                                    <Col className="col-12 mb-3">
                                                                        <label
                                                                            htmlFor="email"
                                                                            className="col-md-12 col-form-label"
                                                                        >
                                                                            Email
                                                                            <span className="t-require">*</span>
                                                                        </label>
                                                                        <div className="col-md-12">
                                                                            <Input
                                                                                id="email"
                                                                                className="form-control"
                                                                                type="text"
                                                                                placeholder=""
                                                                                name="email"
                                                                                onChange={e => {
                                                                                    validation.setFieldValue(
                                                                                        "email",
                                                                                        e.target.value
                                                                                    )
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.email}
                                                                                invalid={
                                                                                    validation.touched.email &&
                                                                                        validation.errors.email
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                                disabled={pageView === "view"}
                                                                            />
                                                                            {validation.touched.email &&
                                                                                validation.errors.email && (
                                                                                    <FormFeedback type="invalid">
                                                                                        {validation.errors.email}
                                                                                    </FormFeedback>
                                                                                )}
                                                                        </div>
                                                                        <hr />
                                                                    </Col>
                                                                    <Col className="col-12 mb-3">
                                                                        <label
                                                                            htmlFor="topic"
                                                                            className="col-md-12 col-form-label"
                                                                        >
                                                                            Topic
                                                                            <span className="t-require">*</span>
                                                                        </label>
                                                                        <div className="col-md-12">
                                                                            <Input
                                                                                id="topic"
                                                                                className="form-control"
                                                                                type="text"
                                                                                placeholder=""
                                                                                name="topic"
                                                                                onChange={e => {
                                                                                    validation.setFieldValue(
                                                                                        "topic",
                                                                                        e.target.value
                                                                                    )
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.topic}
                                                                                invalid={
                                                                                    validation.touched.topic &&
                                                                                        validation.errors.topic
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                                disabled={pageView === "view"}
                                                                            />
                                                                            {validation.touched.topic &&
                                                                                validation.errors.topic && (
                                                                                    <FormFeedback type="invalid">
                                                                                        {validation.errors.topic}
                                                                                    </FormFeedback>
                                                                                )}
                                                                        </div>
                                                                        <hr />
                                                                    </Col>
                                                                    <Col className="col-12 mb-3">
                                                                        <label
                                                                            htmlFor="message"
                                                                            className="col-md-12 col-form-label"
                                                                        >
                                                                            Message
                                                                            <span className="t-require">*</span>
                                                                        </label>
                                                                        <div className="col-md-12">
                                                                            <Input
                                                                                id="message"
                                                                                className="form-control"
                                                                                type="textarea"
                                                                                placeholder=""
                                                                                name="message"
                                                                                rows="15"
                                                                                onChange={e => {
                                                                                    validation.setFieldValue(
                                                                                        "message",
                                                                                        e.target.value
                                                                                    )
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.message}
                                                                                invalid={
                                                                                    validation.touched.message &&
                                                                                        validation.errors.message
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                                disabled={pageView === "view"}
                                                                            />
                                                                            {validation.touched.message &&
                                                                                validation.errors.message && (
                                                                                    <FormFeedback type="invalid">
                                                                                        {validation.errors.message}
                                                                                    </FormFeedback>
                                                                                )}
                                                                        </div>
                                                                        <hr />
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col className="col-4">
                                                <Card
                                                    outline
                                                    color="primary"
                                                    className="border sticky-element"
                                                >
                                                    <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                                                        <i className="bx bx-check"></i> Tools Box
                                                    </h5>
                                                    <CardBody>
                                                        <Row>
                                                            {/* <Col className="col-12 mb-3">
                                                                <label
                                                                    htmlFor="category_name"
                                                                    className="col-md-12 col-form-label"
                                                                >
                                                                    Switch Language
                                                                    <span className="t-require">*</span>
                                                                </label>
                                                                <div className="col-md-12">
                                                                    <InputLang
                                                                        widthfull
                                                                        pageView={pageView}
                                                                        forceRoute={false}
                                                                    />
                                                                </div>
                                                            </Col> */}
                                                            <Col className="col-12 mb-3">
                                                                <label
                                                                    htmlFor="postDate"
                                                                    className="col-md-12 col-form-label"
                                                                >
                                                                    Written at
                                                                    <span className="t-require">*</span>
                                                                </label>
                                                                <div className="col-md-12">
                                                                    <InputGroup>
                                                                        <Flatpickr
                                                                            className="form-control d-block"
                                                                            options={{
                                                                                dateFormat: "d/m/Y", // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                                                            }}
                                                                            value={
                                                                                validation.values.postDate
                                                                                    ? moment(
                                                                                        validation.values
                                                                                            .postDate,
                                                                                        "YYYY-MM-DD"
                                                                                    ).toDate()
                                                                                    : null
                                                                            }
                                                                            disabled={true}
                                                                        />
                                                                        <div className="input-group-append">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-outline-secondary docs-datepicker-trigger"
                                                                                disabled
                                                                            >
                                                                                <i
                                                                                    className="fa fa-calendar"
                                                                                    aria-hidden="true"
                                                                                />
                                                                            </button>
                                                                        </div>
                                                                    </InputGroup>
                                                                    {validation.touched.postDate &&
                                                                        validation.errors.postDate && (
                                                                            <div
                                                                                type="invalid"
                                                                                className="invalid-feedback d-block"
                                                                            >
                                                                                {validation.errors.postDate}
                                                                            </div>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col className="col-12 mb-3">
                                                                <Input type="hidden" value="active" />
                                                                {/* <label
                                                                    htmlFor="category_name"
                                                                    className="col-md-12 col-form-label"
                                                                >
                                                                    Display
                                                                    <span className="t-require">*</span>
                                                                </label>
                                                                <div className="col-md-12">
                                                                    <Select
                                                                        placeholder="Select Status"
                                                                        value={fn_helper.FNFORM.getObjectValue(
                                                                            STATUS_OPTION,
                                                                            `${validation.values.contentStatus}`
                                                                        )}
                                                                        onChange={value =>
                                                                            validation.setFieldValue(
                                                                                "contentStatus",
                                                                                value.id
                                                                            )
                                                                        }
                                                                        getOptionValue={option => option.id}
                                                                        getOptionLabel={option => option.name}
                                                                        options={STATUS_OPTION}
                                                                        className={`select2-selection ${validation.touched.contentStatus &&
                                                                                validation.errors.contentStatus
                                                                                ? "input-err"
                                                                                : ""
                                                                            }`}
                                                                        isDisabled={pageView === "view"}
                                                                    />
                                                                    {validation.touched.contentStatus &&
                                                                        validation.errors.contentStatus && (
                                                                            <div
                                                                                type="invalid"
                                                                                className="invalid-feedback d-block"
                                                                            >
                                                                                {validation.errors.contentStatus}
                                                                            </div>
                                                                        )}
                                                                </div> */}
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                    <CardFooter>
                                                        <Row>
                                                            <Col className="text-start">
                                                                <Button
                                                                    color="danger"
                                                                    className="btn btn-danger"
                                                                    onClick={() =>
                                                                        navigate(`/${_routeLink}`)
                                                                    }
                                                                >
                                                                    Back
                                                                </Button>
                                                            </Col>
                                                            <Col className="text-end">
                                                                {pageView !== "view" && (
                                                                    <Button
                                                                        type="submit"
                                                                        className="btn btn-success"
                                                                    >
                                                                        Save{" "}
                                                                        {waitSendData ? (
                                                                            <Spinner size="sm" color="light" />
                                                                        ) : null}
                                                                    </Button>
                                                                )}
                                                            </Col>
                                                        </Row>
                                                    </CardFooter>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Form>
                                </FormikProvider>
                            </Col>
                        </Row>
                    )}
                </Container>
            </div>
        </React.Fragment>
    )
}

// QuestionaireCategory.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(ContactUsFormTemplate)
